/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-assignment */
import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { memo } from 'react';

export interface Props {
  count: number
  disabled?: boolean
  image: string
  name: string
  onChange: () => void
  selected?: boolean
}

function ProductCatalogFilterCard(props: Props) {
  return <FormControlLabel
    checked={props.selected}
    control={<Checkbox color="secondary" />}
    disabled={props.disabled}
    disableTypography
    label={<Stack
      direction="row"
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        flexGrow: 1,
        minWidth: 0,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0 }}>
        <img src={require('@resources/img/all-products/filters/' + props.image + '.svg?url')} alt={props.name} style={{ maxWidth: '35px' }} />
        <Typography variant="body2" sx={{ fontWeight: props.selected ? '600' : '400' }}>{props.name}</Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary">{props.count}</Typography>
    </Stack>}
    labelPlacement="start"
    onChange={() => props.onChange()}
    sx={{
      alignItems: 'center',
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      justifyContent: 'space-between',
      margin: 0,
      opacity: props.disabled ? 0.45 : 1,
      width: '100%',

      '& .MuiFormControlLabel-label': {
        flexGrow: 1,
        minWidth: 0,
      },
    }}
  />
}

export default memo(ProductCatalogFilterCard);
